import { render } from "./NavbarHome.vue?vue&type=template&id=2898f156&scoped=true"
import script from "./NavbarHome.vue?vue&type=script&lang=js"
export * from "./NavbarHome.vue?vue&type=script&lang=js"

import "./NavbarHome.vue?vue&type=style&index=0&id=2898f156&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\personal\\ims-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2898f156"]])

export default __exports__